import { render, staticRenderFns } from "./CardDefault.vue?vue&type=template&id=6e455180&scoped=true&"
import script from "./CardDefault.vue?vue&type=script&lang=ts&"
export * from "./CardDefault.vue?vue&type=script&lang=ts&"
import style0 from "./CardDefault.vue?vue&type=style&index=0&id=6e455180&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e455180",
  null
  
)

export default component.exports